import { render, staticRenderFns } from "./MessageUser.vue?vue&type=template&id=17d3da36&scoped=true"
import script from "./MessageUser.vue?vue&type=script&lang=js"
export * from "./MessageUser.vue?vue&type=script&lang=js"
import style0 from "./MessageUser.vue?vue&type=style&index=0&id=17d3da36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d3da36",
  null
  
)

export default component.exports